import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Chip from 'Chip';
import errorBoundary from '@ifeng/errorBoundary';
import Slides from '@ifeng/ui_pc_slides';
import { formatImage } from '@ifeng/public_method';
import { Event } from '@ifeng/ui_base';
import { rel } from '../../../../../utils/rel';
import styles from './index.css';
import RecPicList from './recPicList/';
import { handleAd } from '../../../../../utils/handleAd';

const PicTitle = errorBoundary(
    class extends PureComponent {
        static propTypes = {
            content: PropTypes.object,
        };

        render() {
            const { content } = this.props;

            return (
                <div className={styles.col_d_box}>
                    <a href={content.url} target="_blank" rel={rel}>
                        <img src={content.logo} className={styles.col_d_box_tPic} />
                    </a>
                </div>
            );
        }
    },
);

const Content = errorBoundary(
    class extends PureComponent {
        static propTypes = {
            content: PropTypes.object,
        };

        constructor(props) {
            super(props);

            this.event = new Event();

            this.state = {
                slideBoxData: props.content.slideBoxData,
            };
        }

        sliderTmpl = item => {
            let thumbnail = '';

            if (item.thumbnail) {
                thumbnail = item.thumbnail;
            } else if (
                item.thumbnail ||
                (item.thumbnails && item.thumbnails.image && item.thumbnails.image[0] && item.thumbnails.image[0].url)
            ) {
                thumbnail = item.thumbnails.image[0].url;
            }

            return item.type === 'ad' ? (
                <div className={styles.bigPic} ref={item.ref} />
            ) : (
                <div className={styles.bigPic}>
                    <a href={item.url} className={styles.pic_img} target="_blank" rel={rel}>
                        <img src={thumbnail ? formatImage(thumbnail, 690, 400) : ''} className={styles.trans} />
                    </a>
                    <div className={styles.text} />
                    <p className={styles.title}>
                        <a href={item.url} target="_blank" rel={rel}>
                            {item.title}
                        </a>
                    </p>
                </div>
            );
        };

        // insertArr 为广告方想要插入的一组位置，replaceArr 为广告方想要替换的一组位置，adFn 为回调方法
        insert = (insertArr, replaceArr, adFn) => {
            if (adFn && typeof adFn === 'function') {
                const { slideBoxData } = this.state;
                const infoData = [...slideBoxData];
                const refs = [];

                // 广告插入，在指定位置后插入广告位数据
                insertArr.forEach(item => {
                    const ref = React.createRef();

                    refs.push({ index: item, ref });

                    infoData.splice(item, 0, { type: 'ad', ref });
                });

                // 广告替换，在指定位置删除原数据，替换为广告位数据
                replaceArr.forEach(item => {
                    const ref = React.createRef();

                    refs.push({ index: item, ref });

                    infoData.splice(item, 1, { type: 'ad', ref });
                });

                // 广告数据整合处理完毕后，更新列表数据
                this.setState(
                    {
                        slideBoxData: infoData,
                    },
                    () => {
                        const dom = {};

                        for (const ref of refs) {
                            dom[ref.index] = ref.ref.current;
                        }

                        adFn(dom);
                    },
                );
            }

            return;
        };

        async componentDidMount() {
            try {
                const {
                    content: { ad_slide },
                } = this.props;
                const callback = await handleAd(ad_slide);

                // 将自定义广告插入方法传入，这样广告方即可调用
                callback(ad_slide.data, this.event, this.insert);
            } catch (e) {
                console.error(e);
            }

            try {
                this.adInit();
            } catch (e) {
                console.error(e);
            }
        }

        adInit = data => {
            try {
                // 触发广告位插入方法
                this.event.trigger('init', { data });
            } catch (e) {
                console.error(e);
            }
        };

        render() {
            const {
                content: { recommendData, rightRecTitlePic },
            } = this.props;

            const { slideBoxData } = this.state;

            const slideConfig = {
                sliderTmpl: this.sliderTmpl,
                dotStyle: styles.dotStyle,
                dotCurrentStyle: styles.dotCurrentStyle,
            };

            return (
                <div className={styles.rBox}>
                    <div className={styles.bannerPic}>
                        <Chip
                            id="55030"
                            type="recommend"
                            title="轮播图前三帧推荐位"
                            groupName="推荐位"
                            content={slideBoxData}>
                            <Slides content={slideBoxData} config={slideConfig} />
                        </Chip>
                    </div>
                    <div className={styles.col_d_right}>
                        <Chip
                            id="30084"
                            type="struct"
                            title="右侧推荐位图片标题"
                            groupName="content"
                            content={rightRecTitlePic}>
                            <PicTitle />
                        </Chip>
                        <Chip
                            id="55031"
                            type="recommend"
                            title="右侧三条图片推荐位"
                            groupName="推荐位"
                            content={recommendData}>
                            <RecPicList />
                        </Chip>
                    </div>
                </div>
            );
        }
    },
);

export { Content };
export default Content;
